import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoggingService } from '../../services/logging.service';
import { catchError, throwError } from 'rxjs';
import { HANDLE_400, HANDLE_404, HANDLE_409, SUPPRESS_ERROR_TOAST } from '../constants/context-tokens';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const loggingService = inject(LoggingService);
  const skip400 = req.context.get(HANDLE_400);
  const skip404 = req.context.get(HANDLE_404);
  const skip409 = req.context.get(HANDLE_409);
  const skipAll = req.context.get(SUPPRESS_ERROR_TOAST);

  return next(req).pipe(
    catchError((error: any) => {
      if (
        skipAll ||
        (error.status === 400 && skip400) ||
        (error.status === 404 && skip404) ||
        (error.status === 409 && skip409)
      ) {
        return throwError(() => error);
      }

      loggingService.error(error?.error?.title ?? 'Error', error);
      return throwError(() => error);
    })
  );
};
